<script setup lang="ts">
const props = defineProps({
  featuredImage: {
    type: Object,
  },
});
</script>

<template>
  <div class="item__image">
    <NuxtImg
      class="car-image"
      :src="props.featuredImage?.src || '/img/placeholder.png'"
      preset="thumbnail"
      placeholder="/img/placeholder.png"
      alt=""
    />
  </div>
</template>

<style lang="scss" scoped>
.item__image {
  width: 200px;
  height: auto;

  @media only screen and (max-width: $laptopS) {
    width: 100%;
    height: 400px;
  }

  @media only screen and (max-width: $tablet) {
    height: 250px;
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
</style>
